<template>
    <div id="barea">
        <div class="bdisp msgdisp">count : {{ num }}</div>
        <div class="bdisp bata">
            <button id="buttonTest" @click="countNum" v-if="$parent.endMsg==''">押せ！</button>
            <button id="buttonTest" @click="countNum" v-if="$parent.endMsg==''">押せ！</button>
        </div>

        <div class="bdisp msgdisp">{{ message }}</div>
    </div>
</template>
<script>
    export default {
        el: 'ButtonTest',
        data: function () {
            return {
                num: 0,
            }
        },
        methods: {
            countNum: function () {
                this.num++
                if(this.num > 10 && this.num < 30){
                    this.message = "あたたた！！"
                }else if(this.num > 30 && this.num < 50){
                    this.message = "あた、あたたた！！"
                }else if(this.num > 50 && this.num < 80){
                    this.message = "あた！！あたたた！！"
                }else if(this.num > 80 && this.num < 100){
                    this.message = "あた！！！！あたたた！！"
                }else if(this.num > 100 && this.num < 130){
                    this.message = "あーあたたた！！あた！！！"
                }else if(this.num > 130 && this.num < 150){
                    this.message = "あたた！！！！あた、あたたた！！"
                }else if(this.num > 150 && this.num < 180){
                    this.message = "あーあーあーあーあーあたたた！！"
                }else if(this.num > 180 && this.num < 200){
                    this.message = "あああああ、あたたたたた！！"
                }else if(this.num > 200){
                    this.message = "ああああああああああああああ"
                }
            },
        }
    };
    </script>

<style scoped>
#barea{
    background-color: rgba(120, 0, 120, 0.3);
    min-height: 250px;
    margin: 50px;
    padding-top: 25px;
}
.bdisp{
    display: flex;
    align-items: center;
    justify-content: center;
}
.msgdisp {
    font-size: 50px;
}
.bata button{
    margin: 5px;
    background: rgba(205, 0, 0, 0.5);
}
</style>